export default __webpack_public_path__ + "static/media/test_kino_parkplatz_besucher_kinofilm_start.e781746b.jpg";